'use strict';

export default class ResetPasswordController 
{
	/*@ngInject*/
	constructor(Auth, $log, ValidationService) 
	{
		this.Auth = Auth;
		this.$log = $log;
		this.validation = new ValidationService();
	}

	Submit(form) 
	{
		this.success = null;
		this.error = null;

		if (!this.validation.checkFormValidity(form)) {
			// Aqui no saco mensajes, porque con el del error de validación del campo es suficiente
			return;
		}

		this.Auth.resetPasswordRequest(this.email)
		.then(response => {
			this.success = response.data;
		})
		.catch(err => {
			this.$log.warn(err.data);
			this.error = err.data;
		});
	}
}



// WEBPACK FOOTER //
// ./client/app/account/other/resetpassword.controller.js